"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var WarningIcon = function WarningIcon() {
  return _react["default"].createElement("svg", {
    style: {
      verticalAlign: 'middle'
    },
    height: "1em",
    width: "1em",
    viewBox: "0 0 24 24"
  }, _react["default"].createElement("path", {
    d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z",
    fill: "#FFC81B",
    fillRule: "evenodd"
  }));
};
var _default = exports["default"] = WarningIcon;